// extracted by mini-css-extract-plugin
export var markdown = "_vs-0";
export var tableWrapper = "_vs-1";